/**
 * Plugin de verificação automática de expiração Pro
 * 
 * Este plugin:
 * - Verifica se o Pro expirou ao fazer login
 * - Atualiza o perfil automaticamente se expirado
 * - Mostra notificação ao usuário
 * - Executa verificação periódica (a cada 1 hora)
 */

export default {
    install(Vue, { store }) {
        // Verificar expiração
        const checkExpiration = async () => {
            const user = store.state.auth.user;
            if (!user) return;
            
            const profileStatus = store.getters['auth/profileStatus'];
            
            // Se Pro expirou, atualizar perfil
            if (profileStatus.isExpired && profileStatus.isTemporary) {
                try {
                    // Atualizar perfil do usuário
                    await store.dispatch('auth/ActionRefreshProfile');
                    
                    // Mostrar notificação
                    Vue.swal({
                        icon: 'warning',
                        title: 'Acesso Premium Expirado',
                        text: 'Seu acesso Premium expirou e foi alterado para Free. Entre em contato para renovar.',
                        confirmButtonText: 'Entendi'
                    });
                } catch (error) {
                    console.error('Erro ao atualizar perfil:', error);
                }
            }
        };
        
        // Verificar ao fazer login
        store.subscribe((mutation, state) => {
            if (mutation.type === 'auth/SET_USER' && state.auth.user) {
                // Aguardar um pouco para garantir que o perfil foi carregado
                setTimeout(checkExpiration, 1000);
            }
        });
        
        // Verificação periódica (a cada 1 hora)
        setInterval(checkExpiration, 60 * 60 * 1000);
        
        // Verificar imediatamente se já está logado
        if (store.state.auth.user) {
            checkExpiration();
        }
    }
};
